export default "__VITE_ASSET__BvomD$0O__"